import valerie from "assets/team/valerie.jpg";
import anita from "assets/team/anita.jpg";
import efe from "assets/team/efe.jpg";
import bola from "assets/team//bola.png";
// import kolade from "assets/team/kolade.png";
import iyanu from "assets/team/iyanu.png";
// import bola from "assets/team/bola.jpg";
import adetutu from "assets/advisors/adetutu.jpg";
import dayo from "assets/advisors/dayo.png";
import go from "assets/advisors/go.jpg";
import vf from "assets/advisors/vf.jpg";
import { ReactComponent as LinkedIn } from "assets/frameworks/linkedin.svg";
import daniel from "assets/team/daniel.jpg";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
// import nurudeen from "assets/advisors/nurudeen.jpg";
import david from "assets/advisors/david.png";
import aderonke from "assets/advisors/ronke.jpg";
import sarah from "assets/advisors/sarah.jpg";
import steve from "assets/advisors/steve.jpg";

export default function Team() {
  const advisors = [
    {
      name: "Gbemisola Osunrinde",
      role: "Chief Executive Officer",
      linkedin: "https://www.linkedin.com/in/oluwagbemisolaoguntade/",
      image: go,
      key: "go",
    },
    {
      name: "Daniel Obot",
      role: "SVP, Growth",
      linkedin: "https://www.linkedin.com/in/danieljonesobot/",
      image: daniel,
      key: "daniel",
    },
    {
      name: "Valerie Azubuike",
      role: "SVP, Human Resources",
      linkedin: "https://www.linkedin.com/in/valerie-azubuike-phri-/ ",
      image: valerie,
      key: "valerie",
    },
    {
      name: "Bola Lateef-Odeshina",
      role: "Head, Customer Success and Compliance",
      linkedin: "https://www.linkedin.com/in/bola-lateef-odeshina-b084b9268/",
      image: bola,
      key: "bola",
    },
    {
      name: "Anita Ajalla",
      role: "Chief Technology Officer",
      linkedin: "https://www.linkedin.com/in/amara-ajalla/ ",
      image: anita,
      key: "anita",
    },
    // {
    //   name: "Kolade Onanogbo",
    //   role: "Product Designer",
    //   linkedin: "https://www.linkedin.com/in/kolade-ononogbo/",
    //   image: kolade,
    //   key: "kolade",
    // },
    {
      name: "Efe Ohwonigho",
      role: "SVP, Operations",
      linkedin: "https://www.linkedin.com/in/efe-ohwonigho-41a585a2/",
      image: efe,
      key: "efe",
    },

    {
      name: "Iyanuoluwa Ogundipe",
      role: "Lead, Offensive Intelligence",
      linkedin: "https://www.linkedin.com/in/iyanuoluwaogundipe",
      image: iyanu,
      key: "iyanu",
    },
    // {
    //   name: "Dr. Victor Funmipe",
    //   role: "Ag. Chief Product Officer",
    //   linkedin: "https://www.linkedin.com/in/victor-f-phd-mba-07533436/",
    //   image: vf,
    //   key: "vf",
    // },
    {
      name: "Dayo Koleowo",
      role: "Board Advisory Investment - Secure",
      linkedin: "https://www.linkedin.com/in/natekorl/?originalSubdomain=uk",
      image: dayo,
      key: "dayo",
    },
    // {
    // 	name: 'Nurudeen Odeshina',
    // 	role: 'Board Advisory Cybersecurity - Secure',
    // 	linkedin: 'https://www.linkedin.com/in/nurudeenodeshina',
    // 	image: nurudeen,
    // 	key: 'nurudeen'
    // },
    {
      name: "Adetutu Ogunsowo",
      role: "Board Advisory Cybersecurity - Adhere",
      linkedin: "https://www.linkedin.com/in/adetutuogunsowo",
      image: adetutu,
      key: "adetutu",
    },
    {
      name: "Dr. Olufunso Steve Olofinlade",
      role: "Board Advisory Human Resources - Smartcomply",
      linkedin:
        "https://www.linkedin.com/in/olufunso-steve-olofinlade-cphr-shrm-gphr-7755701b/",
      image: steve,
      key: "steve",
    },
    {
      name: "Professor Thompson Aderonke Favour-Bethy",
      role: "Board Advisory Research and Development Academy - Academy",
      linkedin: "https://www.linkedin.com/in/aderonke-thompson",
      image: aderonke,
      key: "aderonke",
    },
    {
      name: "David Omole",
      role: "Board Advisory Operations - Secure",
      linkedin: "",
      image: david,
      key: "david",
    },
    {
      name: "Sarah Chidebelu-Eze",
      role: "Board Advisory Sales and Partnership - Smartcomply",
      linkedin: "https://www.linkedin.com/in/sarah-chidebelu-eze/",
      image: sarah,
      key: "sarah",
    },
  ];

  const { t } = useTranslation("about");

  return (
    <>
      <section className=" px-14 max-md:px-8 max-[520px]:px-4 max-lg:py-12 bg-white">
        <div id="advisors" className="pb-20 max-lg:pb-12">
          <div className="mb-5">
            <h3 className="text-black font-semibold max-md:text-[28px] text-[44px] text-left font-lexend w-[50%]">
              {t(`team.title`)}
            </h3>
          </div>

          <div className="grid grid-cols-4 max-[1200px]:grid-cols-3 max-[900px]:grid-cols-2 max-[500px]:grid-cols-1 h-auto gap-4">
            {advisors.map((member) => {
              const firstname = member.name.split(" ")[0];
              const nameHasTitle =
                firstname.includes("Dr.") || firstname.includes("Professor");
              return (
                <div
                  key={member.name}
                  className="relative rounded-xl overflow-hidden group"
                >
                  {/* Image */}
                  <img
                    src={member.image}
                    alt={member.name}
                    className="object-[top] h-full max-h-[460px] w-full rounded-xl object-cover
               transition-transform duration-[1000ms] ease-in-out
               group-hover:scale-125"
                  />

                  {/* Bottom Overlay */}
                  <div className="absolute bottom-0 left-0 w-full">
                    <div className="bg-gradient-to-t from-black/80 via-black/50 to-transparent p-4 pt-8">
                      <div className="space-y-2 text-left">
                        {/* Name */}
                        <h5
                          className={`${
                            member.key === "aderonke" || member.key === "steve"
                              ? "leading-none max-[1200px]:leading-normal"
                              : ""
                          } text-white text-lexend text-base`}
                        >
                          <span className="font-bold">
                            {nameHasTitle
                              ? member.name.split(" ")[0] +
                                " " +
                                member.name.split(" ")[1]
                              : firstname}{" "}
                          </span>
                          {member.name
                            .split(" ")
                            .slice(nameHasTitle ? 2 : 1)
                            .join(" ")}
                        </h5>

                        {/* Role */}
                        <p className="text-[#FFFFFFB2]">
                          {t(`team.${member.key}`)}
                        </p>

                        {/* LinkedIn */}
                        {member.linkedin && (
                          <Link
                            to={member.linkedin}
                            target="_blank"
                            className="flex gap-2 items-center"
                          >
                            <LinkedIn className="w-[20px] h-[20px]" />
                            <p className="text-sm text-white">LinkedIn</p>
                          </Link>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
